define('OutSystems/ClientRuntime/modules/Storage/InMemoryStorage',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var InMemoryStorage = (function () {
        function InMemoryStorage(other) {
            this.storageObj = {};
            if (!!other) {
                var i = 0;
                var key = other.key(i);
                while (key !== null) {
                    this.storageObj[key] = other.getItem(key);
                    key = other.key(++i);
                }
            }
        }
        Object.defineProperty(InMemoryStorage.prototype, "length", {
            get: function () {
                return Object.keys(this.storageObj).length;
            },
            enumerable: false,
            configurable: true
        });
        InMemoryStorage.prototype.clear = function () {
            this.storageObj = {};
        };
        InMemoryStorage.prototype.getItem = function (key) {
            return this.storageObj.hasOwnProperty(key) ? this.storageObj[key] : null;
        };
        InMemoryStorage.prototype.key = function (index) {
            var keys = Object.keys(this.storageObj);
            return index < keys.length ? keys[index] : null;
        };
        InMemoryStorage.prototype.removeItem = function (key) {
            if (this.storageObj.hasOwnProperty(key)) {
                delete this.storageObj[key];
            }
        };
        InMemoryStorage.prototype.setItem = function (key, data) {
            this.storageObj[key] = data;
        };
        return InMemoryStorage;
    }());
    exports.default = InMemoryStorage;
});
//# sourceMappingURL=InMemoryStorage.js.map;
